import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Criar uma nova oferta',
  subtitle: 'Como é que o cliente obtém um item gratuito?',
  validation: {
    required: 'Selecione um tipo de oferta',
  },
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Valor total do pedido',
      description: 'Ex: 10% de desconto no pedido ao gastar 20 {{currency}}',
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      name: 'Itens selecionados',
      description: 'Ex: 10% de desconto em pizzas de 12 polegadas.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      name: 'Itens selecionados',
      description: 'Ex: 1 {{currency}} de desconto em pizzas de 12 polegadas.',
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      name: 'Valor total do pedido',
      description: 'Ex: 1 {{currency}} de desconto no pedido ao gastar 20 {{currency}}',
    },
    [OFFER_KIND.BOGO]: {
      name: 'Compre 1 leve 2 grátis',
      description: 'Ex: Compre 1 pizza e leve outra grátis. A pizza mais barata é descontada.',
    },
    [OFFER_KIND.BOGO_HALF_PRICE]: {
      name: 'Compre 1 leve 2 a metade do preço',
      description: 'Ex: Compre 1 pizza e leve outra a metade do preço; a pizza mais barata é descontada.',
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      name: 'Ao comprar outro item',
      description: 'Ex: Obtenha uma bebida grátis ao encomendar uma refeição.',
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      name: 'Ao gastar um valor fixo em {{currency}}',
      description: 'Ex: Obtenha uma sobremesa grátis ao gastar 20 {{currency}}.',
    },
  },
};
